export { default } from './IssuesContainer';
